import React, { FC, useState, useRef, CSSProperties } from "react";
import { PopperProps, Fade } from "@mui/material";
import style from "./ArrowPopper.module.scss";
import dynamic from "next/dynamic";
import { useClickAway } from "ahooks/lib";

interface ArrowPopperProps extends PopperProps {
  disableStyle?: boolean;
  handleClose?: () => void;
  disableArrow?: boolean;
  disableFlip?: boolean;
  pageId?: string;
  containerStyle?: CSSProperties;
}

const Popper = dynamic(() => import("@mui/material/Popper"), {
  ssr: false,
});

const ArrowPopper: FC<ArrowPopperProps> = ({
  disableStyle,
  handleClose,
  disableArrow,
  disableFlip,
  pageId,
  containerStyle,
  ...props
}) => {
  const [arrowRef, setArrowRef] = useState<null | HTMLSpanElement>(null);
  const ref = useRef(null);

  const handleArrowRef = (ref: HTMLSpanElement) => {
    setArrowRef(ref);
  };

  useClickAway(() => {
    handleClose?.();
  }, [ref, props.anchorEl as any]);

  return (
    <Popper
      className={style.root}
      transition={true}
      placement={pageId === "email-contact" ? "left" : "bottom"}
      modifiers={[
        {
          name: "flip",
          enabled: !disableFlip,
        },
        {
          name: "arrow",
          enabled: false,
          options: {
            element: arrowRef,
          },
        },
        {
          name: "preventOverflow",
          enabled: true,
          options: {
            boundary: "scrollParent",
          },
        },
      ]}
      {...props}
    >
      {({ TransitionProps }) => (
        <Fade
          {...TransitionProps}
          timeout={{ exit: 0 }}
        >
          <div ref={ref}>
            {/* {!disableArrow ? (
              <span className={style.arrow} ref={handleArrowRef} />
            ) : null} */}
            <div
              className={disableStyle ? "" : style.pop}
              style={containerStyle}
            >
              {(props as any).children}
            </div>
          </div>
        </Fade>
      )}
    </Popper>
  );
};

export default ArrowPopper;
